import { Box, Typography } from "@mui/material";
import MetaGlobal from "../types/negocio/MetaGlobal";
import { EmptyMessage } from "./EmptyMessage";

interface CardMetasGlobaisProps {
    area: string;
    metas: MetaGlobal[];
}

export default function CardMetasGlobais({ area, metas }: CardMetasGlobaisProps) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <Typography fontSize={14} sx={{ color: "#607C90" }}>
                {area}
            </Typography>

            {metas.length === 0 ? (
                <EmptyMessage> </EmptyMessage>
            ) : (
                metas.map((meta) => (
                    <Typography key={meta.guid} fontSize={16}>
                        - {meta.meta}
                    </Typography>
                ))
            )}
        </Box>
    );
}